import React from 'react';
import { Link } from 'react-router-dom';
import mainIcon from '../assets/main.png';
import collectionIcon from '../assets/collection.png';
import creatorIcon from '../assets/creator.png';
import storyIcon from '../assets/story.png';
import marketIcon from '../assets/market.png';
import profileIcon from '../assets/profile.png';
import padlockIcon from '../assets/padlock.png';

export default function Sidebar({ activePage = null }) {
  const renderNavItem = (to, icon, label, isActive) => {
    if (isActive) {
      return (
        <div className="relative" style={{ marginBottom: 'clamp(12px, 0.63vw, 12px)' }}>
          {/* Background overlay */}
          <div 
            className="absolute rounded-[2px]"
            style={{
              left: '0',
              top: '0',
              width: '100%',
              height: label === 'Profile' ? 'clamp(45px, 3.1vw, 60px)' : 'clamp(40px, 2.8vw, 55px)',
              backgroundColor: '#A6A6A6',
              opacity: 0.2,
              pointerEvents: 'none'
            }}
          />
          
          {/* Red accent line */}
          <div 
            className="absolute rounded-l-[2px]"
            style={{
              left: '0',
              top: '0',
              width: 'clamp(4px, 0.31vw, 6px)',
              height: label === 'Profile' ? 'clamp(45px, 3.1vw, 60px)' : 'clamp(40px, 2.8vw, 55px)',
              backgroundColor: '#CC0000',
              pointerEvents: 'none'
            }}
          />
          
          {/* Button content */}
          <Link 
            to={to}
            className="relative flex items-center hover:opacity-80 transition-opacity w-full"
            style={{
              paddingLeft: 'clamp(17px, 1.35vw, 26px)',
              height: label === 'Profile' ? 'clamp(45px, 3.1vw, 60px)' : 'clamp(40px, 2.8vw, 55px)',
              gap: 'clamp(9px, 0.77vw, 15px)',
              textDecoration: 'none'
            }}
          >
            <img 
              src={icon} 
              alt={label}
              style={{
                width: 'clamp(16px, 1.25vw, 24px)',
                height: 'clamp(16px, 1.25vw, 24px)',
                opacity: 1,
                flexShrink: 0
              }}
            />
            
            <span 
              style={{
                fontFamily: 'Nova Square',
                fontWeight: 400,
                fontSize: 'clamp(10px, 0.95vw, 18px)',
                lineHeight: 'normal',
                color: '#FFFFFF',
                opacity: 0.7
              }}
            >
              {label}
            </span>
          </Link>
        </div>
      );
    } else {
      return (
        <Link 
          to={to}
          className="flex items-center hover:opacity-80 transition-opacity w-full"
          style={{
            paddingLeft: 'clamp(17px, 1.35vw, 26px)',
            height: label === 'Profile' ? 'clamp(45px, 3.1vw, 60px)' : 'clamp(40px, 2.8vw, 55px)',
            marginBottom: label === 'Profile' ? '0' : 'clamp(12px, 0.63vw, 12px)',
            gap: 'clamp(9px, 0.77vw, 15px)',
            textDecoration: 'none'
          }}
        >
          <img 
            src={icon} 
            alt={label}
            style={{
              width: 'clamp(16px, 1.25vw, 24px)',
              height: 'clamp(16px, 1.25vw, 24px)',
              opacity: 0.7,
              flexShrink: 0
            }}
          />
          
          <span 
            style={{
              fontFamily: 'Nova Square',
              fontWeight: 400,
              fontSize: 'clamp(10px, 0.95vw, 18px)',
              lineHeight: 'normal',
              color: '#FFFFFF',
              opacity: 0.7
            }}
          >
            {label}
          </span>
        </Link>
      );
    }
  };

  const renderLockedItem = (icon, label, borderColor = '#790E0E', lockBgColor = '#721212') => {
    return (
      <div className="relative" style={{ 
        marginBottom: label === 'Market' ? 'clamp(24px, 1.98vw, 38px)' : 'clamp(12px, 0.63vw, 12px)',
        height: 'clamp(40px, 2.8vw, 55px)'
      }}>
        <div 
          className="absolute rounded-[2px]"
          style={{
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            backgroundColor: '#131313',
            pointerEvents: 'none',
            zIndex: 1
          }}
        />
        
        <div 
          className="absolute rounded-[2px]"
          style={{
            left: '0',
            top: '0',
            width: '100%',
            height: '1px',
            backgroundColor: borderColor,
            opacity: label === 'Story' || label === 'Market' ? 1 : 0.8,
            pointerEvents: 'none',
            zIndex: 3
          }}
        />
        
        <div 
          className="absolute rounded-[2px]"
          style={{
            left: '0',
            bottom: '0',
            width: '100%',
            height: '1px',
            backgroundColor: borderColor,
            opacity: 1,
            pointerEvents: 'none',
            zIndex: 3
          }}
        />
        
        <div 
          className="absolute rounded-[2px]"
          style={{
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            backgroundColor: '#484848',
            opacity: 0.15,
            pointerEvents: 'none',
            zIndex: 2
          }}
        />
        
        <div 
          className="absolute rounded-l-[4px]"
          style={{
            right: '0',
            top: '-5px',
            width: 'clamp(26px, 2.64vw, 51px)',
            height: 'calc(100% + 10px)',
            backgroundColor: lockBgColor,
            opacity: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
            zIndex: 4
          }}
        >
          <img 
            src={padlockIcon}
            alt="Locked"
            style={{
              width: 'clamp(14px, 1.44vw, 28px)',
              height: 'clamp(14px, 1.44vw, 28px)',
              opacity: 1
            }}
          />
        </div>
        
        <button 
          className="relative flex items-center w-full cursor-not-allowed h-full"
          style={{
            paddingLeft: 'clamp(17px, 1.35vw, 26px)',
            gap: 'clamp(9px, 0.77vw, 15px)'
          }}
          disabled
        >
          <img 
            src={icon} 
            alt={label}
            style={{
              width: 'clamp(16px, 1.25vw, 24px)',
              height: 'clamp(16px, 1.25vw, 24px)',
              opacity: 0.7,
              flexShrink: 0,
              zIndex: 5
            }}
          />
          
          <span 
            style={{
              fontFamily: 'Nova Square',
              fontWeight: 400,
              fontSize: 'clamp(10px, 0.95vw, 18px)',
              lineHeight: 'normal',
              color: '#FFFFFF',
              opacity: 0.7,
              zIndex: 5
            }}
          >
            {label}
          </span>
        </button>
      </div>
    );
  };

  return (
    <aside 
      className="bg-[#131313] border-r-4 border-[#830C0C] flex flex-col flex-shrink-0 relative" 
      style={{ 
        width: 'clamp(200px, 12.5vw, 240px)',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        zIndex: 20
      }}
    >
      <nav className="flex flex-col" style={{ paddingTop: 'clamp(50px, 4.06vw, 78px)' }}>
        
        {/* Main */}
        {renderNavItem('/', mainIcon, 'Main', activePage === 'main')}

        {/* Collection */}
        {renderNavItem('/collection', collectionIcon, 'Collections', activePage === 'collection')}

        {/* Creator's - Locked */}
        {renderLockedItem(creatorIcon, "Creator's", '#790E0E', '#721212')}

        {/* Story - Locked */}
        {renderLockedItem(storyIcon, 'Story', '#721212', '#721212')}

        {/* Market - Locked */}
        {renderLockedItem(marketIcon, 'Market', '#790E0E', '#790E0E')}

        {/* Divider line */}
        <div 
          style={{
            width: 'calc(100% - clamp(23px, 2.16vw, 42px))',
            height: '1px',
            backgroundColor: '#D9D9D9',
            marginLeft: 'clamp(14px, 1.2vw, 23px)',
            marginBottom: 'clamp(10px, 1.28vw, 24px)'
          }}
        />

        {/* Profile */}
        {renderNavItem('/profile', profileIcon, 'Profile', activePage === 'profile')}
      </nav>
    </aside>
  );
}

